module.exports = __webpack_public_path__ + "static/ecommerce4-a5f595c62a0a2bac4ceca99af4eacafb.jpg";